export function personalVehicleInfo(vehicle) {
  return [
    {
      id: 1,
      spanSize: "col-span-1",
      label: "Placa",
      value: vehicle?.licensePlate,
    },
    { id: 2, spanSize: "col-span-1", label: "Marca", value: vehicle?.brand },
    { id: 3, spanSize: "col-span-1", label: "Modelo", value: vehicle?.model },
    {
      id: 4,
      spanSize: "col-span-1",
      label: "Ano do modelo",
      value: vehicle?.yearModel,
    },
    {
      id: 5,
      spanSize: "col-span-1",
      label: "Ano de fabricação",
      value: vehicle?.year,
    },
    {
      id: 6,
      spanSize: "col-span-1",
      label: "Código Renavam",
      value: vehicle?.renavam,
    },
    { id: 7, spanSize: "col-span-1", label: "Chassi", value: vehicle?.chassi },
    {
      id: 8,
      spanSize: "col-span-1",
      label: "Combustível",
      value: vehicle?.fuel,
    },
    {
      id: 9,
      spanSize: "col-span-1",
      label: "Hodômetro Velotrack",
      value: vehicle?.odometer,
    },
    {
      id: 10,
      spanSize: "col-span-1",
      label: "Hodômetro Locavibe",
      value: vehicle?.odometerLocavibe,
    },
    {
      id: 11,
      spanSize: "col-span-1",
      label: "Número do motor",
      value: vehicle?.motorNumber,
    },
    {
      id: 12,
      spanSize: "col-span-1",
      label: "Cor predominante",
      value: vehicle?.color,
    },
    {
      id: 13,
      spanSize: "col-span-1",
      label: "Titular",
      value: vehicle?.partnerInfo?.companyName,
    },
    {
      id: 14,
      spanSize: "col-span-1",
      label: "Sua Vibe",
      value: vehicle?.partnerInfo?.isEligibleSuaVibe ? "Sim" : "Não",
    },
  ];
}
export function velotrackVehicleInfo(vehicle) {
  return [
    {
      id: 12,
      spanSize: "col-span-2 row-span-1",
      label: "Código Velotrack",
      value: vehicle?.velotrackSettings?.deviceId,
    },
    {
      id: 13,
      spanSize: "col-span-2 row-span-1",
      label: "Código Fipe",
      value: vehicle?.fipeInfo?.fipeVehicleCode,
    },
  ];
}

export function vehicleCRLVInfo(vehicle) {
  return [
    { label: "CRLV", href: `https://assets.locavibe.com.br/${vehicle.crlv}` },
  ];
}

export function vehicleNFInfo(vehicle) {
  return [
    {
      label: "Nota fiscal",
      href: `https://assets.locavibe.com.br/${vehicle.nf}`,
    },
  ];
}
